import { render, staticRenderFns } from "./HomeBody.vue?vue&type=template&id=4f8fa26c&scoped=true&"
import script from "./HomeBody.vue?vue&type=script&lang=js&"
export * from "./HomeBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8fa26c",
  null
  
)

export default component.exports